import React, { ReactElement } from 'react';
import Tab from '@tovia/man-ui/lib/components/Tab/Tab';

export interface CountTabProps {
  value: string;
  count?: number;
  name: string | ReactElement;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

export default function CountTab(props: CountTabProps) {
  const { name, value, count, ...rest } = props;

  return (
    <Tab key={value} {...rest}>
      {name}
      {(count || 0) > 0 && (
        <span>
          &nbsp;
          <small>({count || 0})</small>
        </span>
      )}
    </Tab>
  );
}
